/*
* 阔地教育科技有限公司版权所有（codyy.com/codyy.cn）.
* Copyright (c) 2019, Codyy and/or its affiliates. All rights reserved.
* @Date: 2020.01.01 13:04.
* @Author
* @Description 请求CODE枚举 --- 返回参数 status 的状态值 用作拦截器统一使用
**/

export const SUCCESS = '0' // 成功
export const EXPIRED = '100000004' // token过期
export const ERROR = '-1' // 失败
